module.exports = __webpack_public_path__ + "components/flag/static/square/bs-8cc8a46ac2b5ed683e6dc45021ef1702.svg";